import {commitMutation, graphql} from 'react-relay';
import type {Environment, Disposable} from 'relay-runtime';
import {csrfToken, socketClientId} from '../../../forecast-app/ticketing/graphql/forecastRelay';
import type {savedFiltersDeleteMutation, DeleteSavedFilterInput} from './__generated__/savedFiltersDeleteMutation.graphql';

const mutation = graphql`
	mutation savedFiltersDeleteMutation($input: DeleteSavedFilterInput!) {
		deleteSavedFilter(input: $input) {
			clientMutationId
			deletedId
		}
	}
`;

function commit(
	environment: Environment,
	input: DeleteSavedFilterInput,
	onCompleted?: (r: savedFiltersDeleteMutation['response']) => void,
	onError?: (e: Error) => void
): Disposable {
	return commitMutation<savedFiltersDeleteMutation>(environment, {
		mutation,
		variables: {
			input: {csrfToken: csrfToken(), socketClientId: socketClientId(), ...input},
		},
		onCompleted: onCompleted ? response => onCompleted(response) : undefined,
		onError: onError ? error => onError(error) : undefined,
	});
}

export default {commit, mutationId: 'savedFiltersDeleteMutation'};
